import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { PROVEED } from './types';
import { RootState } from "@/store/modules/general/types";

const namespaced = true;

type ProveedoresModule = Module<PROVEED, RootState>;

export const Proveedores: ProveedoresModule = {
    namespaced,
    actions,
    getters,
    mutations,
}